// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import type { ScoreboardV2Props } from '../../states/scoreboards';
import theme from '../../styled-components/dark';
import HistoryDefaultScoreboard from '../HistoryDefaultScoreboard';
import ScoreboardRowSetsLayout from '../ScoreboardRowSetsLayout';
import ScoreboardSetsLayout from '../ScoreboardSetsLayout';

const Wrapper = styled.div``;

const MatchTitle = styled.div`
  color: ${theme.History.outcome.match.color};
  font-size: 0.77em;
`;

const ScoreboardWrapper = styled.div`
  font-size: 0.74em;
  margin-top: 0.25em;
`;

const StyledScoreboardSetsLayout = styled(ScoreboardSetsLayout)`
  font-size: 0.65em;
  margin-top: 0.28em;
`;

type HistoryMatchFullTitleProps = ScoreboardV2Props & {
  className?: string;
  matchId?: string;
  title?: string;
  isSetLayout?: boolean;
  hasVoidReason?: boolean;
};

const HistoryMatchFullTitle = ({ className, ...props }: HistoryMatchFullTitleProps) => {
  const { isLive, isEnded, title, isSetLayout, scores, competitors, hasVoidReason } = props;

  const hasScores = useMemo(() => {
    const score = scores?.main?.score ?? [];
    return (
      (isLive || isEnded) &&
      ((score.length > 1 && score[0] !== '' && score[1] !== '') || scores?.secondaries?.length > 0)
    );
  }, [scores, isLive, isEnded]);

  const hasCompetitorsName = useMemo(
    () => competitors.length > 1 && !!competitors[0].name && !!competitors[1].name,
    [competitors],
  );

  const titleHeader = useMemo(() => {
    if (isLive && isSetLayout) {
      return (
        <ScoreboardWrapper>
          <ScoreboardRowSetsLayout {...props} light />
        </ScoreboardWrapper>
      );
    }
    if (hasScores && !hasVoidReason) {
      if (isSetLayout) {
        return <StyledScoreboardSetsLayout {...props} hideLabel light hideScorer />;
      }
      if (hasCompetitorsName) {
        return <HistoryDefaultScoreboard {...props} />;
      }
    }

    if (title) {
      return <MatchTitle>{title}</MatchTitle>;
    }

    return <HistoryDefaultScoreboard {...props} />;
  }, [hasScores, hasCompetitorsName, isLive, isSetLayout, title, hasVoidReason, props]);

  return <Wrapper className={className}>{titleHeader}</Wrapper>;
};

export default HistoryMatchFullTitle;
